/** @file Chords browsers never deliver to pages (per browser); binding one fails the check. */

export const RESERVED_CHORDS = {
  chromium: [
    'Ctrl+KeyN', 'Ctrl+KeyT', 'Ctrl+KeyW', 'Ctrl+Tab', 'Ctrl+Shift+KeyN', 'Ctrl+Shift+KeyT', 'Ctrl+Shift+KeyW',
    'Ctrl+Shift+Tab', 'Ctrl+Shift+KeyQ', 'Ctrl+PageUp', 'Ctrl+PageDown', 'Meta+KeyQ', 'Alt+F4',
  ],
  firefox: [
    'Ctrl+KeyN', 'Ctrl+KeyT', 'Ctrl+KeyW', 'Ctrl+Tab', 'Ctrl+Shift+KeyN', 'Ctrl+Shift+KeyT', 'Ctrl+Shift+KeyW',
    'Ctrl+Shift+Tab', 'Ctrl+PageUp', 'Ctrl+PageDown', 'Meta+KeyQ', 'Alt+F4',
  ],
} as const;
